export enum Roles {
  Admin = 'ADMIN',
  User = 'USER',
  Audit = 'AUDIT',
  Metrics = 'METRICS',
  Operations = 'OPERATIONS',
  Demo = 'DEMO',
  UserManagement = 'USER_MANAGEMENT',
  AIOCR = 'AIOCR',
  Main = 'MAIN',
}

export enum SCOPES {
  canAccessOperations = 'canAccessOperations',
  canAccessDashboard = 'canAccessDashboard',
  canViewOperations = 'canViewOperations',
  canViewAudit = 'canViewAudit',
  canViewUX = 'canViewUX',
  canViewUserManagment = 'canViewUserManagment',
  canViewVideo = 'canViewVideo',
  canViewAntifraud = 'canViewAntifraud',
  canViewStudio = 'canViewStudio',
  canViewPrivacy = 'canViewPrivacy',
  canViewAI = 'canViewAI',
  canWriteOperations = 'canWriteOperations',
  canViewBehaviour = 'canViewBehaviour',
  canViewCiam = 'canViewCiam',
  canViewBuilder = 'canViewBuilder',
}

export const PERMISSIONS = {
  [Roles.Admin]: [
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
    SCOPES.canViewVideo,
    SCOPES.canViewAntifraud,
    SCOPES.canViewUserManagment,
  ],
  [Roles.UserManagement]: [SCOPES.canViewUserManagment],
  [Roles.User]: [
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
    SCOPES.canViewVideo,
    SCOPES.canViewAntifraud,
  ],
  [Roles.Audit]: [
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
    SCOPES.canWriteOperations,
    SCOPES.canViewVideo,
    // SCOPES.canViewAudit,
  ],
  [Roles.Operations]: [
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
  ],
  [Roles.Metrics]: [SCOPES.canViewUX],
  [Roles.Demo]: [
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
    SCOPES.canViewVideo,
    SCOPES.canWriteOperations,
    SCOPES.canViewAntifraud,
    SCOPES.canViewPrivacy,
    SCOPES.canViewBuilder,
    // SCOPES.canViewStudio,
    SCOPES.canViewAI,
    SCOPES.canViewUserManagment,
    SCOPES.canViewUX,
    SCOPES.canViewBehaviour,
    SCOPES.canViewCiam,
  ],
  [Roles.AIOCR]: [SCOPES.canViewAI],
  [Roles.Main]: [
    SCOPES.canViewAI,
    SCOPES.canViewAntifraud,
    SCOPES.canViewBuilder,
    SCOPES.canViewOperations,
    SCOPES.canAccessDashboard,
    SCOPES.canAccessOperations,
  ],
};
